import { render, staticRenderFns } from "./ScrollHelper.vue?vue&type=template&id=2973b038"
import script from "./ScrollHelper.vue?vue&type=script&lang=js"
export * from "./ScrollHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports